import { render } from "./VirtualRedTagUnavailable.vue?vue&type=template&id=5467c0d6&scoped=true&ts=true"
import script from "./VirtualRedTagUnavailable.vue?vue&type=script&lang=ts"
export * from "./VirtualRedTagUnavailable.vue?vue&type=script&lang=ts"

import "./VirtualRedTagUnavailable.vue?vue&type=style&index=0&id=5467c0d6&lang=scss&scoped=true"

import exportComponent from "/builds/knx-core/freightbox/freightbox-monorepo-vue/services/eleos-driver-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5467c0d6"]])

export default __exports__